import $ from 'jquery';

$(document).ready(() => {
    $(document).on('change', '.answer input[type=radio]', function () {
        const $selectedAnswerRadio = $(this);

        if (!$selectedAnswerRadio.is(':checked')) {
            return;
        }

        cleanNextElements($selectedAnswerRadio);

        const answerDataSet = $selectedAnswerRadio.data();
        const answer = surveyQuestions[answerDataSet.question].answers[answerDataSet.index];

        if (!answer) {
            return;
        }

        let nextElement;

        if (answer.final) {
            nextElement = generateOffersElement(answer.offers_label, answer.offers)
        } else {
            const nextQuestion = surveyQuestions[answer.next_question];

            if (!nextQuestion) {
                return;
            }

            nextElement = generateQuestionElement(nextQuestion);
        }

        $('.survey').append(nextElement);
        scrollTo(nextElement);
    });
});

function cleanNextElements($answerRadio) {
    $answerRadio.parents('.level').nextAll().remove();
}

function generateOffersElement(text, offers) {
    text = text || '';

    const $element = $(`
        <div class="level final-response">
            <h2>${text}</h2>
            <div class="row"></div>
        </div>
    `);

    offers.forEach((offer) => {
        $element.find('.row').append(`
        <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="content-offre">
                <div class="content-img">
                    <img src="${offer.image}" alt="${offer.post_name}">
                    <div class="content-text">
                        <div class="content-title">
                            <h2>${offer.title}</h2>
                        </div>
                        <div class="content-sub">
                            <p>${offer.description}</p>
                        </div>
                    </div>
                    <div class="link">
                        <a href="${offer.permalink}">Découvrir</a>
                    </div>
                </div>
            </div>
        </div>
        `);
    });

    return $element;
}

function generateQuestionElement(question) {
    const $element = $(`
        <div id="${question.reference}" class="level">
            <h2>${question.label}</h2>
            <div class="limit iso">
            <div class="row justify-content-center"></div>
            </div>
        </div>
    `);

    question.answers.forEach((answer, index) => {
        const id = 'match_' + question.reference + index;
        $element.find('.row').append(`
            <div class="col-lg-3 col-md-6 col-sm-12">
                <p class="answer">
                    <input
                        type="radio"
                        name="${question.reference}"
                        id="${id}"
                        data-question="${question.reference}"
                        data-index="${index}"
                    >
                    <label for="${id}">
                    <span class="content-all">
                        <span class="svg">${answer.icon}</span>
                        <span class="text">${answer.label}</span>
                    </span>
                    </label>
                </p>
            </div>
        `);
    });

    return $element;
}

function scrollTo($element) {
    const additionalPadding = 40;
    $('html, body').animate(
        {scrollTop: $element.offset().top - $('#masthead').outerHeight() - additionalPadding},
        1500
    );
}